import axios from 'axios';
import { ApiError } from '../../error';

// Card 288 — guest review replies and moderation. PROTOTYPE.
const url = '/api/v1/tipdirect/guest-reviews';

export const fetchGuestReviews = () => {
  return axios
    .get(url)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const publishReviewReply = ({ reviewId, body, draftedByAi }) => {
  return axios
    .put(`${url}/${reviewId}/reply`, { body, draftedByAi })
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const deleteReviewReply = reviewId => {
  return axios
    .delete(`${url}/${reviewId}/reply`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

// Returns a draft for the operator to edit. Never publishes it.
export const draftReviewReply = reviewId => {
  return axios
    .post(`${url}/${reviewId}/reply/draft`)
    .then(res => res.data.data.draft)
    .catch(ApiError.ofAndThrow);
};

// The caller sends a reason, never a status. The server derives whether this
// takes the review out of the rating — see resolveModerationStatus.
export const moderateReview = ({ reviewId, reason, note }) => {
  return axios
    .put(`${url}/${reviewId}/moderation`, { reason, note })
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

// How many of your guests we keep, rather than sending on to Tripadvisor.
export const fetchReviewSplit = () => {
  return axios
    .get(`${url}/split`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const saveReviewSplit = percentage => {
  return axios
    .put(`${url}/split`, { percentage })
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

// Bad review alerts: on/off, how bad is bad enough, where they go, how often.
export const fetchReviewAlerts = () => {
  return axios
    .get(`${url}/alerts`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const saveReviewAlerts = settings => {
  return axios
    .put(`${url}/alerts`, settings)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

// The operator's public profile on the review portal.
export const fetchPortalProfile = () => {
  return axios
    .get(`${url}/profile`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const savePortalProfile = profile => {
  return axios
    .put(`${url}/profile`, profile)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};

export const restoreReview = reviewId => {
  return axios
    .delete(`${url}/${reviewId}/moderation`)
    .then(res => res.data.data)
    .catch(ApiError.ofAndThrow);
};
